export default __webpack_public_path__ + "static/media/5-Ensaios.5d5edbd5.png";